import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import AuthContainer from "../components/AuthContainer";
import { getInviteErrorMessage } from "../components/User/inviteErrorMessages";

export type InviteErrorCode =
  | "INVITE_TOKEN_INVALID"
  | "INVITE_TOKEN_EXPIRED"
  | "VERIFICATION_LOCKED"
  | "RATE_LIMIT_EXCEEDED";

interface InviteErrorPageProps {
  code: InviteErrorCode;
}

const headings: Record<InviteErrorCode, string> = {
  INVITE_TOKEN_EXPIRED: "Your Invite Has Expired",
  INVITE_TOKEN_INVALID: "Invite Link Invalid",
  VERIFICATION_LOCKED: "Verification Temporarily Locked",
  RATE_LIMIT_EXCEEDED: "Please Wait a Moment",
};

const followups: Partial<Record<InviteErrorCode, string>> = {
  INVITE_TOKEN_EXPIRED: "Please contact your administrator to resend.",
  INVITE_TOKEN_INVALID: "Please contact your administrator to resend.",
  VERIFICATION_LOCKED: "You can try again shortly, or contact your administrator if this persists.",
  RATE_LIMIT_EXCEEDED: "Please wait a minute and refresh the page to try again.",
};

export const InviteErrorPage: React.FC<InviteErrorPageProps> = ({ code }) => {
  const heading = headings[code];
  const message = getInviteErrorMessage(code);
  const followup = followups[code];

  return (
    <AuthContainer
      welcomeOverrideText=""
      additionalHeadingText={
        <div className="flex flex-row gap-4 mt-20">
          <FiAlertTriangle className="mb-4 h-10 w-10 fill-amber-400 text-black" />
          {heading}
        </div>
      }
    >
      <p data-testid="invite-error-message">{message}</p>
      {followup && (
        <p className="mt-6" data-testid="invite-error-followup">
          {followup}
        </p>
      )}
    </AuthContainer>
  );
};
